/**
 * Store Registration — Client-side JS
 * Handles: store-conditional proof field, file upload, form validation, submission to Vercel API
 */
(function() {
  'use strict';

  var API_BASE = 'https://api-nu-jade-59.vercel.app';

  // File upload state
  var selectedFile = null;

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    setupStoreConditional();
    setupFileUpload();
    setupForm();
  }

  // ==================== STORE CONDITIONAL ====================
  function setupStoreConditional() {
    var storeSelect = document.getElementById('reg-store');
    if (!storeSelect) return;

    var proofMap = {
      'Unity Asset Store': {
        label: 'Unity Invoice Number',
        placeholder: 'e.g., IN1234567890 (found in Unity order history or receipt email)'
      },
      'FAB': {
        label: 'FAB Account Email or Order Reference',
        placeholder: 'Your Epic Games account email or order reference number'
      },
      'Blender Market': {
        label: 'Blender Market Username',
        placeholder: 'Your Blender Market username (visible in your profile URL)'
      },
      'itch.io': {
        label: 'itch.io Email, Username, or Download Key',
        placeholder: 'The email you used on itch.io, your username, or download key from receipt'
      },
      'TurboSquid': {
        label: 'TurboSquid Order Number',
        placeholder: 'Your TurboSquid order number from confirmation email'
      },
      'Humble Bundle': {
        label: 'Humble Bundle Email or Order Key',
        placeholder: 'The email you used for Humble Bundle or order key'
      },
      'Other': {
        label: 'Purchase Details',
        placeholder: 'Please describe where and when you purchased, plus any order reference'
      }
    };

    storeSelect.addEventListener('change', function() {
      var labelEl = document.getElementById('reg-proof-label');
      var inputEl = document.getElementById('reg-proof');
      if (!labelEl || !inputEl) return;

      var mapping = proofMap[storeSelect.value];
      if (mapping) {
        labelEl.innerHTML = mapping.label + ' <span class="reg-required">*</span>';
        inputEl.placeholder = mapping.placeholder;
      } else {
        labelEl.innerHTML = 'Proof of Purchase <span class="reg-required">*</span>';
        inputEl.placeholder = 'Select a store above to see what info we need';
      }
    });
  }

  // ==================== FILE UPLOAD ====================
  function setupFileUpload() {
    var fileInput = document.getElementById('reg-screenshot');
    var dropzone = document.getElementById('reg-dropzone');
    var preview = document.getElementById('reg-upload-preview');
    var previewImg = document.getElementById('reg-preview-img');
    var filenameEl = document.getElementById('reg-filename');
    var removeBtn = document.getElementById('reg-remove-file');

    if (!fileInput || !dropzone) return;

    var MAX_SIZE = 4 * 1024 * 1024; // 4MB
    var ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];

    // Click dropzone to trigger file input
    dropzone.addEventListener('click', function() {
      fileInput.click();
    });

    // File input change
    fileInput.addEventListener('change', function() {
      if (fileInput.files && fileInput.files[0]) {
        handleFile(fileInput.files[0]);
      }
    });

    // Drag and drop
    dropzone.addEventListener('dragover', function(e) {
      e.preventDefault();
      dropzone.classList.add('reg-upload__dropzone--dragover');
    });

    dropzone.addEventListener('dragleave', function() {
      dropzone.classList.remove('reg-upload__dropzone--dragover');
    });

    dropzone.addEventListener('drop', function(e) {
      e.preventDefault();
      dropzone.classList.remove('reg-upload__dropzone--dragover');
      if (e.dataTransfer.files && e.dataTransfer.files[0]) {
        handleFile(e.dataTransfer.files[0]);
      }
    });

    // Remove button
    if (removeBtn) {
      removeBtn.addEventListener('click', function() {
        clearFile();
      });
    }

    function handleFile(file) {
      // Validate type
      if (ALLOWED_TYPES.indexOf(file.type) === -1) {
        var msgEl = document.getElementById('reg-form-message');
        showMessage(msgEl, 'Please upload an image file (PNG, JPG, GIF, or WebP).', 'error');
        return;
      }

      // Validate size
      if (file.size > MAX_SIZE) {
        var msgEl = document.getElementById('reg-form-message');
        showMessage(msgEl, 'File is too large. Maximum size is 4MB.', 'error');
        return;
      }

      selectedFile = file;

      // Show preview
      var reader = new FileReader();
      reader.onload = function(e) {
        if (previewImg) previewImg.src = e.target.result;
        if (filenameEl) filenameEl.textContent = file.name + ' (' + formatSize(file.size) + ')';
        if (dropzone) dropzone.style.display = 'none';
        if (preview) preview.style.display = '';
      };
      reader.readAsDataURL(file);
    }

    function clearFile() {
      selectedFile = null;
      fileInput.value = '';
      if (previewImg) previewImg.src = '';
      if (filenameEl) filenameEl.textContent = '';
      if (preview) preview.style.display = 'none';
      if (dropzone) dropzone.style.display = '';
    }

    // Expose clearFile for form reset
    window._regClearFile = clearFile;
  }

  function formatSize(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

  // ==================== FILE UPLOAD TO SERVER ====================
  function uploadFile(file) {
    return new Promise(function(resolve, reject) {
      var reader = new FileReader();
      reader.onload = function() {
        var base64 = reader.result.split(',')[1]; // Remove data:...;base64, prefix

        fetch(API_BASE + '/api/upload', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            fileName: file.name,
            fileData: base64,
            fileType: file.type
          })
        })
        .then(function(resp) { return resp.json(); })
        .then(function(data) {
          if (data.url) {
            resolve(data.url);
          } else {
            reject(new Error(data.error || 'Upload failed'));
          }
        })
        .catch(reject);
      };
      reader.onerror = function() {
        reject(new Error('Failed to read file'));
      };
      reader.readAsDataURL(file);
    });
  }

  // ==================== FORM SUBMISSION ====================
  function setupForm() {
    var form = document.getElementById('reg-submit-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var submitBtn = document.getElementById('reg-submit-btn');
      var msgEl = document.getElementById('reg-form-message');

      var name = form.querySelector('#reg-name').value.trim();
      var email = form.querySelector('#reg-email').value.trim();
      var store = form.querySelector('#reg-store').value;
      var proof = form.querySelector('#reg-proof').value.trim();
      var howHeard = form.querySelector('#reg-howheard').value.trim();
      var notes = form.querySelector('#reg-notes').value.trim();
      var consent = form.querySelector('#reg-consent').checked;

      var packs = getCheckedValues('packs');
      var wants = getCheckedValues('wants');

      // Validate required fields
      if (!name) {
        showMessage(msgEl, 'Please enter your full name.', 'error');
        form.querySelector('#reg-name').focus();
        return;
      }

      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showMessage(msgEl, 'Please enter a valid email address.', 'error');
        form.querySelector('#reg-email').focus();
        return;
      }

      if (!store) {
        showMessage(msgEl, 'Please select the store where you purchased.', 'error');
        form.querySelector('#reg-store').focus();
        return;
      }

      if (!packs) {
        showMessage(msgEl, 'Please select at least one pack you purchased.', 'error');
        return;
      }

      if (!proof) {
        showMessage(msgEl, 'Please provide your proof of purchase.', 'error');
        form.querySelector('#reg-proof').focus();
        return;
      }

      if (!consent) {
        showMessage(msgEl, 'Please confirm this is your purchase to continue.', 'error');
        return;
      }

      // Disable button
      submitBtn.disabled = true;
      submitBtn.textContent = 'Submitting...';
      msgEl.style.display = 'none';

      // If there's a file, upload it first, then submit form
      var uploadPromise;
      if (selectedFile) {
        submitBtn.textContent = 'Uploading screenshot...';
        uploadPromise = uploadFile(selectedFile);
      } else {
        uploadPromise = Promise.resolve('');
      }

      uploadPromise
        .then(function(screenshotUrl) {
          submitBtn.textContent = 'Submitting...';

          var payload = {
            name: name,
            email: email,
            store: store,
            packs: packs,
            proof: proof,
            screenshotUrl: screenshotUrl || '',
            wants: wants || '',
            howHeard: howHeard || '',
            notes: notes || '',
            consent: consent
          };

          return fetch(API_BASE + '/api/register', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
        })
        .then(function(resp) { return resp.json(); })
        .then(function(data) {
          if (data.success) {
            showMessage(msgEl, data.message || 'Registration submitted successfully! We\'ll verify your purchase and email you within a few business days.', 'success');
            form.reset();
            // Reset proof label back to default
            var labelEl = document.getElementById('reg-proof-label');
            if (labelEl) {
              labelEl.innerHTML = 'Proof of Purchase <span class="reg-required">*</span>';
            }
            var inputEl = document.getElementById('reg-proof');
            if (inputEl) {
              inputEl.placeholder = 'Select a store above to see what info we need';
            }
            // Clear file preview
            if (window._regClearFile) window._regClearFile();
          } else {
            showMessage(msgEl, data.error || 'Something went wrong. Please try again.', 'error');
          }
        })
        .catch(function(err) {
          showMessage(msgEl, err.message || 'Network error. Please check your connection and try again.', 'error');
        })
        .finally(function() {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Register My Purchase';
        });
    });
  }

  // ==================== HELPERS ====================
  function getCheckedValues(name) {
    var checked = document.querySelectorAll('input[name="' + name + '"]:checked');
    var values = [];
    for (var i = 0; i < checked.length; i++) {
      values.push(checked[i].value);
    }
    return values.join(', ');
  }

  function showMessage(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'reg-form__message reg-form__message--' + type;
    el.style.display = '';
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

    if (type === 'success') {
      setTimeout(function() { el.style.display = 'none'; }, 10000);
    }
  }

})();
